"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var elementWidth_1 = require("./elementWidth");

function notEnoughChildren(state) {
  var slidesToShow = state.slidesToShow;
  return state.totalItems < slidesToShow;
}

function getInitialState(state, props) {
  var flexBisis,
      domLoaded = state.domLoaded,
      slidesToShow = state.slidesToShow,
      containerWidth = state.containerWidth,
      itemWidth = state.itemWidth,
      deviceType = props.deviceType,
      responsive = props.responsive,
      ssr = props.ssr,
      partialVisbile = props.partialVisbile,
      partialVisible = props.partialVisible,
      domFullyLoaded = Boolean(domLoaded && slidesToShow && containerWidth && itemWidth);
  ssr && deviceType && !domFullyLoaded && (flexBisis = elementWidth_1.getWidthFromDeviceType(deviceType, responsive));
  var shouldRenderOnSSR = Boolean(ssr && deviceType && !domFullyLoaded && flexBisis);
  return {
    shouldRenderOnSSR: shouldRenderOnSSR,
    flexBisis: flexBisis,
    domFullyLoaded: domFullyLoaded,
    partialVisibilityGutter: elementWidth_1.getPartialVisibilityGutter(responsive, partialVisbile || partialVisible, deviceType, state.deviceType),
    shouldRenderAtAll: shouldRenderOnSSR || domFullyLoaded
  };
}

function getIfSlideIsVisbile(index, state) {
  var currentSlide = state.currentSlide,
      slidesToShow = state.slidesToShow;
  return currentSlide <= index && index < currentSlide + slidesToShow;
}

function getTransformForCenterMode(state, props, transformPlaceHolder) {
  var transform = transformPlaceHolder || state.transform;
  return !props.infinite && 0 === state.currentSlide || notEnoughChildren(state) ? transform : transform + state.itemWidth / 2;
}

function isInLeftEnd(_a) {
  return !(0 < _a.currentSlide);
}

function isInRightEnd(_a) {
  var currentSlide = _a.currentSlide,
      totalItems = _a.totalItems;
  return !(currentSlide + _a.slidesToShow < totalItems);
}

function getTransformForPartialVsibile(state, partialVisibilityGutter, props, transformPlaceHolder) {
  void 0 === partialVisibilityGutter && (partialVisibilityGutter = 0);
  var currentSlide = state.currentSlide,
      slidesToShow = state.slidesToShow,
      isRightEndReach = isInRightEnd(state),
      shouldRemoveRightGutter = !props.infinite && isRightEndReach,
      baseTransform = transformPlaceHolder || state.transform;
  if (notEnoughChildren(state)) return baseTransform;
  var transform = baseTransform + currentSlide * partialVisibilityGutter;
  return shouldRemoveRightGutter ? transform + (state.containerWidth - (state.itemWidth - partialVisibilityGutter) * slidesToShow) : transform;
}

function getTransform(state, props, transformPlaceHolder) {
  var partialVisbile = props.partialVisbile,
      partialVisible = props.partialVisible,
      responsive = props.responsive,
      deviceType = props.deviceType,
      centerMode = props.centerMode,
      transform = transformPlaceHolder || state.transform,
      partialVisibilityGutter = elementWidth_1.getPartialVisibilityGutter(responsive, partialVisbile || partialVisible, deviceType, state.deviceType);
  return partialVisible || partialVisbile ? getTransformForPartialVsibile(state, partialVisibilityGutter, props, transformPlaceHolder) : centerMode ? getTransformForCenterMode(state, props, transformPlaceHolder) : transform;
}

function getSlidesToSlide(state, props) {
  var domLoaded = state.domLoaded,
      slidesToShow = state.slidesToShow,
      containerWidth = state.containerWidth,
      itemWidth = state.itemWidth,
      deviceType = props.deviceType,
      responsive = props.responsive,
      slidesToScroll = props.slidesToSlide || 1,
      domFullyLoaded = Boolean(domLoaded && slidesToShow && containerWidth && itemWidth);
  return props.ssr && props.deviceType && !domFullyLoaded && Object.keys(responsive).forEach(function (device) {
    var slidesToSlide = responsive[device].slidesToSlide;
    deviceType === device && slidesToSlide && (slidesToScroll = slidesToSlide);
  }), domFullyLoaded && Object.keys(responsive).forEach(function (item) {
    var _a = responsive[item],
        breakpoint = _a.breakpoint,
        slidesToSlide = _a.slidesToSlide,
        max = breakpoint.max,
        min = breakpoint.min;
    slidesToSlide && window.innerWidth >= min && window.innerWidth <= max && (slidesToScroll = slidesToSlide);
  }), slidesToScroll;
}

exports.notEnoughChildren = notEnoughChildren, exports.getInitialState = getInitialState, exports.getIfSlideIsVisbile = getIfSlideIsVisbile, exports.getTransformForCenterMode = getTransformForCenterMode, exports.isInLeftEnd = isInLeftEnd, exports.isInRightEnd = isInRightEnd, exports.getTransformForPartialVsibile = getTransformForPartialVsibile, exports.getTransform = getTransform, exports.getSlidesToSlide = getSlidesToSlide;